import { mapDTO } from '@twistezo/ts-dto-mapper'

import type { Schema } from 'features/globalSetup/pages/Defaults/General/schema'
import type { UpdateWorkspaceGeneralConfigurationMutationVariables } from 'gql/graphql'

type From = Schema
type To = UpdateWorkspaceGeneralConfigurationMutationVariables['input']

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({ newDomainsDefaultBranch, workspaceId }: From): To => ({
      newDomainsDefaultBranch: newDomainsDefaultBranch || null,
      workspaceId,
    }),
  )
